import { createContext, useState } from 'react'
import ContactPersonSpecialities from './ContactPersonSpecialities'
import { Drawer } from 'antd'
import isObject from 'lodash/isObject'
import { useSelector } from 'react-redux'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'

export const ContactPersonDrawerContext = createContext()

const DEFAULT_STATE = null

const ContactPersonDrawer = ({ children }) => {
  const t = useSelector(selectTranslate)

  const [selectedUser, setSelectedUser] = useState(DEFAULT_STATE)

  return (
    <>
      <ContactPersonDrawerContext.Provider value={{ setSelectedUser }}>
        {children}
      </ContactPersonDrawerContext.Provider>
      <Drawer
        title={isObject(selectedUser) && t('contact_person_drawer.title', { name: `${selectedUser.firstname} ${selectedUser.lastname}` })}
        width={600}
        visible={!!selectedUser}
        onClose={() => setSelectedUser(DEFAULT_STATE)}
      >
        <ContactPersonSpecialities contactPerson={selectedUser} onClose={() => setSelectedUser(DEFAULT_STATE)} />
      </Drawer>
    </>
  )
}

export default ContactPersonDrawer
